<template>
  <div>
  </div>
</template>

<script>
export default {
  name: 'MoleculeEditionBillingCustomizedPlan',

  created () {
    this.$router.push(`/${this.$t('rPaths.billing')}/${this.$t('mEditionMenu.billing.customizedPlan.subject')}/${this.$route.params.subid}/${this.$t('mEditionMenu.billing.customizedPlan.children.change.subedition')}`)
  }
}
</script>
